<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Dialog</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <ng-container>
    <maced-button buttonId="defaultId" label="Default Dialog" type="link" [url]="currentUrl"
      [queryParams]="{ openDialog: true, dialogType: 'default', dialogStatus: '' }">
    </maced-button>

    <maced-dialog dialogId="Default Dialog" hasAriaLive="assertive" *ngIf="isDialogOpen && dialogType === 'default'">
      <maced-dialog-header dialogHeaderId="Default Dialog Header" [headerAriaLevel]="1" title="Header" icon="icon-user-circle">
      </maced-dialog-header>
      <maced-dialog-content dialogContentId="Default Dialog Content">
        <p>Content will be here</p>
        <maced-input placeholder="Im disable" [hasInputLabel]="true" autocomplete="off" inputId="input5" name="input5" type="text" icon="icon-maximize"
        [required]="false" [disabled]="false" value='' label="Im disable" formID="form1">
      </maced-input>
      </maced-dialog-content>
      <maced-dialog-footer dialogFooterId="Default Dialog Footer">
        <maced-button buttonId="Default Dialog Close 1" color="secondary" label="Close" type="link" [url]="currentUrl"
          [queryParams]="{ openDialog: false }">
        </maced-button>
        <maced-button buttonId="Default Dialog Close 2" color="primary" label="Close" type="link" [url]="currentUrl"
          [queryParams]="{ openDialog: false }">
        </maced-button>
      </maced-dialog-footer>
    </maced-dialog>
  </ng-container>

  <br>
  <br>

  <ng-container>
    <maced-button buttonId="maxminId" label="Maximize Minimize Dialog" type="link"
      [url]="currentUrl" [queryParams]="{ openDialog: true, dialogType: 'maxmin' }">
    </maced-button>

    <maced-dialog dialogId="Maximize Minimize Dialog" *ngIf="isDialogOpen && dialogType === 'maxmin'">
      <maced-dialog-header dialogHeaderId="Maximize Minimize Dialog Header" title="Header" icon="icon-user-circle"
        [hasMaximizeMinimize]="true">
      </maced-dialog-header>
      <maced-dialog-content dialogContentId="Maximize Minimize Dialog Content">
        <p>Content will be here</p>
      </maced-dialog-content>
      <maced-dialog-footer dialogFooterId="Maximize Minimize Dialog Footer">
        <maced-button buttonId="Maximize Minimize Dialog Close 1" color="secondary" label="Close" type="link"
          [url]="currentUrl" [queryParams]="{ openDialog: false }">
        </maced-button>
        <maced-button buttonId="Maximize Minimize Dialog Close 2" color="primary" label="Close" type="link"
          [url]="currentUrl" [queryParams]="{ openDialog: false }">
        </maced-button>
      </maced-dialog-footer>
    </maced-dialog>
  </ng-container>
  <br>
  <br>

  <ng-container>
    <maced-button buttonId="textAreaId" label="Dialog With TextArea" type="link"
      [url]="currentUrl" [queryParams]="{ openDialog: true, dialogType: 'textArea' }">
    </maced-button>
    <maced-dialog [hasTextArea]="true" dialogId="DialogWithTextArea" *ngIf="isDialogOpen && dialogType === 'textArea'">
      <maced-dialog-header dialogHeaderId="DialogWithTextAreaHeader" title="Give feedback"
        [hasMaximizeMinimize]="false">
      </maced-dialog-header>
      <maced-dialog-content dialogContentId="DialogWithTextAreaContent">
        <maced-text-area textAreaId="textAreaId1" name="textAreaId1" label="Student's Book" placeholder="Write your feedback..."
          [maxLength]="maxLength" [(ngModel)]="textAreaNgModel" [hasExceedingTextAlert]="true" exceedingTextMessage = "The maximum number of characters has been reached.">
        </maced-text-area>
      </maced-dialog-content>
      <maced-dialog-footer dialogFooterId="DialogWithTextAreaFooter">
        <maced-button buttonId="DialogWithTextAreaClose1" color="secondary" label="Cancel" type="link"
          [url]="currentUrl" [queryParams]="closequeryparam">
        </maced-button>
        <maced-button buttonId="DialogWithTextAreaClose2" color="primary" label="Save" type="link"
          [url]="currentUrl" [queryParams]="closequeryparam">
        </maced-button>
      </maced-dialog-footer>
    </maced-dialog>
  </ng-container>
</div>